<template>
    <div>
        <div class="card">
            <div class="card-header">
                <span>Для PUSH рассылок</span> &nbsp; 
                <span
                    class="btn btn-sm btn-primary float-right" 
                    @click="add('push')"
                >
                    <span class="fa fa-plus" /> Добавить
                </span>
            </div>
            <div
                v-if="push.length"
                class="card-body"
            >
                <div
                    v-for="(item, index) in push"
                    :key="index"
                    style="position: relative;"
                    class="row pb-2"
                >
                    <div class="input-group col col-md-4">
                        <select
                            v-model="item.type"
                            class="form-control"
                            :class="{'is-invalid': !(item.type)}"
                        >
                            <option
                                v-for="type in types"
                                :key="type.value"
                                :value="type.value"
                            >
                                {{ type.name }}
                            </option>
                        </select>
                    </div>

                    <div class="input-group col col-md-3">
                        <select
                            v-model="item.day"
                            class="form-control"
                            :class="{'is-invalid': !(item.day)}"
                        >
                            <option
                                v-for="dow in dows"
                                :key="dow.value"
                                :value="dow.value"
                            >
                                {{ dow.name }}
                            </option>
                        </select>
                    </div>

                    <div class="input-group col col-md-5">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <span class="fa fa-clock-o" />
                            </span>
                        </div>
                        <date-picker
                            ref="timepicker"
                            v-model="item.time"
                            :config="timepickerconfig"
                            :class="{'is-invalid': !(item.time)}"
                        />

                        <div class="float-right ml-4">
                            <span
                                class="btn btn-danger"
                                @click="push.splice(index, 1)"
                            >
                                <span class="fa fa-trash" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-3">
            <div class="card-header">
                <span>Для EMAIL рассылок</span> &nbsp; 
                <span
                    class="btn btn-primary btn-sm float-right"
                    @click="add('email')"
                >
                    <span class="fa fa-plus" /> Добавить
                </span>
            </div>
            <div
                v-if="email.length"
                class="card-body"
            >
                <div
                    v-for="(item, index) in email"
                    :key="index"
                    style="position: relative;"
                    class="row pb-2"
                >
                    <div class="input-group col col-md-4">
                        <select
                            v-model="item.type"
                            class="form-control"
                            :class="{'is-invalid': !(item.type)}"
                        >
                            <option
                                v-for="type in types"
                                :key="type.value"
                                :value="type.value"
                            >
                                {{ type.name }}
                            </option>
                        </select>
                    </div>

                    <div class="input-group col col-md-3">
                        <select
                            v-model="item.day"
                            class="form-control"
                            :class="{'is-invalid': !(item.day)}"
                        >
                            <option
                                v-for="dow in dows"
                                :key="dow.value"
                                :value="dow.value"
                            >
                                {{ dow.name }}
                            </option>
                        </select>
                    </div>

                    <div class="input-group col col-md-5">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <span class="fa fa-clock-o" />
                            </span>
                        </div>
                        <date-picker
                            ref="timepicker"
                            v-model="item.time"
                            :config="timepickerconfig"
                            :class="{'is-invalid': !(item.time)}"
                        />
                        <div class="float-right ml-4">
                            <span
                                class="btn btn-danger"
                                @click="email.splice(index, 1)"
                            >
                                <span class="fa fa-trash" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <input
            v-model="json"
            type="hidden" 
            autocomplete="off"
            :name="name" 
            :required="required"
        >
    </div>
</template>

<script>
    import datePicker from 'vue-bootstrap-datetimepicker';

    export default {
        name: 'QuickDates',
        props: {
            val: {
                type: String,
                default: '',
            },
            name: {
                type: String,
                default: 'quick_dates',
            },
            placeholder: {
                type: String,
                default: '',
            },
            required: {
                type: Boolean,
                default: true,
            },
            invalid: {
                type: Boolean,
                default: false,
            },
        },
        data: function() {
            return { 
                content: '', 
                push: [],
                email: [],
                json: JSON.stringify({'push': [], 'email': []}),
                pickerActive: false,
                types: [
                    {'name': 'Следующий', 'value': 'next'},
                    {'name': 'Ближайший', 'value': 'this'},
                ],
                dows: [
                    {'name': 'Пн', 'value': 1},
                    {'name': 'Вт', 'value': 2},
                    {'name': 'Ср', 'value': 3},
                    {'name': 'Чт', 'value': 4},
                    {'name': 'Пт', 'value': 5},
                    {'name': 'Сб', 'value': 6},
                    {'name': 'Вс', 'value': 7},
                ],
                timepickerconfig: {
                    format: 'HH:mm',
                    locale: 'ru',
                    stepping: 30,
                    icons: {
                        time: 'fa fa-clock',
                        date: 'fa fa-calendar',
                        up: 'fa fa-arrow-up',
                        down: 'fa fa-arrow-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-calendar-check',
                        clear: 'fa fa-trash-alt',
                        close: 'fa fa-times-circle'
                    }
                }
            }
        },
        watch: {
            push: {
                handler: function (val) {
                    this.toJSON();
                },
                deep: true
            },
            email: { 
                handler: function (val) {
                    this.toJSON();
                },
                deep: true
            }
        },
        mounted: function() {
            if (this.val) {
                let data = JSON.parse(this.val);
                this.push = data['push'];
                this.email = data['email'];
                this.json = this.val; 
            }
        },
        methods: {
            add: function(type) {
                this[type].push(
                    {'type': null, 'day': null, 'time': null}
                ) 
            },
            toJSON: function() {
                this.json = JSON.stringify({'push': this.push, 'email': this.email});
            }
        },
    }
</script>

